// Reselect Selector
// this selector parses state.services to extract a list
// of unique serviceGroup objects, keyed by
// the serviceGroup id:
// {
//   1: { id: 1, name: 'GroupName1' },
//   2: { id: 2, name: 'GroupName2' },
//   ...
// }
import _ from 'lodash';
import { createSelector } from 'reselect';

// state selecting function
const services = state => state.services;

// getServiceGroups returns a list of Service Groups
// keyed by the serviceGroup id
const getServiceGroups = myServices => {
  // handle errors
  if (myServices.errorMessage) {
    return { errorMessage: myServices.errorMessage };
  }

  const serviceGroupsList = _(myServices)
    .map(service => {
      // if the service is visible, return an object
      if (service.showOnline) {
        return {
          id: service.serviceGroupId,
          name: service.serviceGroupName
        };
      }
      return null;
    })
    .uniqBy('id') // remove duplicates
    .compact() // remove ones where showOnline was false
    .value();

  return _.mapKeys(serviceGroupsList, 'id'); // add the serviceGroup id as a key
};

export default createSelector(services, getServiceGroups);



// WEBPACK FOOTER //
// ./src/selectors/ServiceGroupsSelector.js